/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { images } from '../asset/image'
import { THEME } from '../global/Theme'
import './ChartButton.css';

export class IncomeView extends Component {

    componentDidMount() {

    }

    getData(tradeInfo) {

        const { theme } = this.props;

        const myIncomeValue = tradeInfo.getPersonYield()
        const monkeyIncomeValue = tradeInfo.getMonkeyYield()


        const myIncome = (myIncomeValue * 100).toFixed(1) + '%'
        const monkeyIncome = (monkeyIncomeValue * 100).toFixed(1) + '%'

        const myIncomeStyle = myIncomeValue === 0 ? { color: theme.textColor } :
            myIncomeValue > 0 ? { color: THEME.getValuePositiveColor() } : { color: THEME.getValueNegativeColor() };

        const monkeyIncomeStyle = monkeyIncomeValue === 0 ? { color: theme.textColor } : monkeyIncomeValue > 0 ? { color: THEME.getValuePositiveColor() } : { color: THEME.getValueNegativeColor() };

        return { myIncome, monkeyIncome, myIncomeStyle, monkeyIncomeStyle }

    }

    render() {
        const { tradeInfo } = this.props;
        const { myIncomeStyle, monkeyIncomeStyle, myIncome, monkeyIncome } = this.getData(tradeInfo);

        return (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div className="container" style={{ display: 'flex', flexDirection: 'column' }}>
                    <img src={images['monkey']} style={{ width: 36, height: 36 }} />
                    <div style={{ marginTop: -10 }}>
                        <span className="button-text" style={monkeyIncomeStyle}>{monkeyIncome}</span>
                    </div>
                </div>
                <div className="container" style={{ display: 'flex', flexDirection: 'column' }}>
                    <img src={images['avatar']} style={{ width: 36, height: 36 }} />
                    <div style={{ marginTop: -10 }}>
                        <span className="button-text" style={myIncomeStyle}>{myIncome}</span>
                    </div>
                </div>
            </div>

        );
    }
}